// src/components/ui/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * ProtectedRoute
 *
 * Usage:
 *   <Route element={<ProtectedRoute />}>
 *     <Route path="/profile" element={<ProfilePage />} />
 *   </Route>
 *
 *   <Route element={<ProtectedRoute adminOnly />}>
 *     <Route path="/admin/*" element={<AdminDashboard />} />
 *   </Route>
 */
import { Outlet } from 'react-router-dom';

export default function ProtectedRoute({ adminOnly = false }) {
  const { isLoggedIn, isAdmin, authReady } = useAuth();
  const location = useLocation();

  // Wait for session restore before deciding
  if (!authReady) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'60vh' }}>
        <div style={{ textAlign:'center' }}>
          <div style={{ fontSize:32, marginBottom:12 }}>⚡</div>
          <div style={{ fontFamily:'Inter,sans-serif', color:'#6b7280' }}>Loading…</div>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    // Redirect to login, preserve intended destination
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
